import { ref } from 'vue';

const activeTooltipId = ref<symbol | null>(null);

export function useTooltipManager() {
  return { activeTooltipId };
}
